module.exports = __webpack_public_path__ + "img/128x128_star_scannable.7a8f9c8f.svg";